import product from './product';
import list from './list';
import singleProduct from './singleProduct';
import commons from './commons';

export default {
  product,
  list,
  singleProduct,
  commons,
};
